// @flow

import { createStore } from 'redux';
import reducer from './reducer';

const store: Function = (name: string): Function => createStore(reducer[name]);

export default store;
